export class ClassSubjectReqModel {
  className: string;
  subject: string;

  constructor(className: string, subject: string) {
    this.className = className;
    this.subject = subject;
  }
}
